<template>
    <div class="container">
        <div class="row row-cols-1 row-cols-lg-2">
            <div class="col order-1 order-lg-0">
                <div class="font-weight-bold h4">Zapłać kartą</div>
                <hr class="mb-4" />
                <form method="POST" action="/presubscribe">
                    <input type="hidden" name="id" :value="subscription.Id">
                    <div class="tw-h-16 tw-text-center ">
                        <img src="/gfx/przelewy.svg" class="tw-object-contain tw-w-full tw-h-full">
                    </div>
                    <div class="mt-4">
                        <button type="submit" class="button button--alt w-100 mb-3" :disabled="isSubmitting">
                            <button-loader v-if="isSubmitting"></button-loader>
                            <template v-else>
                                <template v-if="lastSubscription && lastSubscription.IsFree == 1"
                                    >Wybieram tą<br />subskrypcję</template
                                >
                                <template v-else
                                    >Zacznij korzystać z 7-dniowego<br />darmowego okresu próbnego</template
                                >
                            </template>
                        </button>
                    </div>
                </form>
                <div class="tw-text-center tw-mb-5">
                    <a href="/cennik" class="tw-text-center tw-text-primary">wybieram inną subskrybcję</a>
                </div>
            </div>
            <div class="col order-0 order-lg-1 mb-6 mb-lg-0">
                <div class="px-0 pl-lg-5">
                    <div class="font-weight-bold h4">Twoja subskrypcja</div>
                    <hr class="mb-4" />
                    <div class="row row-cols-1 row-cols-md-2 align-items-center">
                        <div class="col">
                            <img
                                v-if="settings.LogoPlus"
                                class="subscription__logo img-fluid"
                                :src="`/file/${settings.LogoPlus}`"
                                alt="logo plus"
                            />
                            <div v-else class="subscription__altlogo">Język w 15 minut PLUS</div>
                            <div class="d-flex align-items-center">
                                <img
                                    :src="`/gfx/menu_lang_${student.Lang}.svg`"
                                    alt=""
                                    class="subscription__lang-icon"
                                />
                                <div class="subscription__lang">
                                    Język
                                    {{ langName }}
                                </div>
                            </div>
                        </div>
                        <div class="col text-left text-md-right">
                            <template v-if="lastSubscription && lastSubscription.IsFree == 1">
                                <div class="subscription__price">
                                    {{ promoPrice ? promoPrice : priceFormat }} zł. /
                                    {{ subscription.Name }}
                                </div>
                            </template>
                            <template v-else>
                                <div class="subscription__price subscription__price--free">
                                    {{ promoPrice ? promoPrice : priceFormat }} zł. /
                                    {{ subscription.Name }}
                                </div>
                                <span class="badge badge-warning">Darmowy okres próbny</span>
                            </template>
                        </div>
                    </div>
                    <div v-if="subscription.Voucher" class="tw-text-sm tw-text-primary tw-mt-4 tw-font-medium">
                        Rabat na pierwsze {{ subscription.Months }} {{ monthsName }} aktywowany: -{{ subscription.Voucher.Value }}%, potem {{ priceFormat }} zł.
                    </div>
                    <div v-if="subscription.Items.length" class="subscription__items">
                        <div v-for="item in subscription.Items" :key="`item${item.Id}`" class="subscription__item">
                            <div class="subscription__item-icon">
                                <img src="/gfx/check.svg" alt="fistaszek" />
                            </div>
                            <div class="subscription__item-text" v-html="item.Content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ButtonLoader from './ButtonLoader.vue'

    export default {
        name: 'Cart',
        props: ['student', 'settings', 'subscription', 'lastSubscription'],
        components: { ButtonLoader },
        data() {
            return {
                form: {
                    FirstName: '',
                    LastName: '',
                    CreditCardNumber: '',
                    CreditCardValid: '',
                    CreditCardCVC: '',
                    PromotionCode: '',
                },
                isError: false,
                messages: {},
                isSubmitting: false,
            }
        },
        computed: {
            langName() {
                let text = 'Niemiecki'
                switch (this.student.Lang) {
                    case 'de':
                        text = 'Niemiecki'
                        break
                    case 'es':
                        text = 'Hiszpański'
                        break
                }
                return text
            },
            monthsName() {
                if (this.subscription.Months == 1) {
                    return 'miesiąc'
                }
                if (this.subscription.Months > 1 && this.subscription.Months < 5) {
                    return 'miesiące'
                }
                if (this.subscription.Months >= 5) {
                    return 'miesięcy'
                }
                return 'miesięcy'
            },
            promoPrice() {
                let promoPrice = null
                if (this.subscription.PromoPrice && this.subscription.PromoPrice !== null) {
                    let val = (this.subscription.PromoPrice / 1).toFixed(2).replace('.', ',')
                    promoPrice = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
                }
                return promoPrice
            },
            priceFormat() {
                let val = (this.subscription.Price / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
            },
        },
        methods: {
            async submit() {
                if (!this.isSubmitting) {
                    this.isSubmitting = true
                    try {
                        const formData = new FormData()
                        formData.append('PackageId', this.subscription.Id)
                        formData.append('FirstName', this.form.FirstName)
                        formData.append('LastName', this.form.LastName)
                        formData.append('CreditCardNumber', this.form.CreditCardNumber)
                        formData.append('CreditCardValid', this.form.CreditCardValid)
                        formData.append('CreditCardCVC', this.form.CreditCardCVC)
                        formData.append('PromotionCode', this.form.PromotionCode)

                        const { data } = await this.$http.post('/subscribe', formData, {
                            headers: {
                                'content-type': 'application/x-www-form-urlencoded',
                            },
                        })
                        if (!data.isError) {
                            this.isError = false
                            this.messages = {}
                            this.reset()
                            let url = `${window.location.protocol}//${window.location.host}/ulepsz-do-premium/sukces`
                            if (data.data.IsFree == 1) {
                                url += '?free=1'
                            }
                            window.location.replace(url)
                        } else {
                            this.isError = true
                            this.messages = data.messages
                        }
                    } catch (error) {
                        alert(error)
                    }
                    this.isSubmitting = false
                }
            },
            reset() {
                this.form.FirstName = ''
                this.form.LastName = ''
                this.form.CreditCardNumber = ''
                this.form.CreditCardValid = ''
                this.form.CreditCardCVC = ''
                this.form.PromotionCode = ''
            },
        },
    }
</script>

<style></style>
